class LunaveilHotspots extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const button = event.target.closest('.lv-hotspot__button');
      if (!button) return;
      const hotspot = button.closest('.lv-hotspot');
      const isOpen = hotspot.dataset.open === 'true';
      this.querySelectorAll('.lv-hotspot[data-open="true"]').forEach((item) => {
        item.dataset.open = 'false';
        item.querySelector('.lv-hotspot__button')?.setAttribute('aria-expanded', 'false');
      });
      hotspot.dataset.open = String(!isOpen);
      button.setAttribute('aria-expanded', String(!isOpen));
    });
    document.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() { document.removeEventListener('keydown', this.onKeydown); }

  onKeydown = (event) => {
    if (event.key !== 'Escape') return;
    this.querySelectorAll('.lv-hotspot[data-open="true"]').forEach((item) => {
      item.dataset.open = 'false';
      item.querySelector('.lv-hotspot__button')?.setAttribute('aria-expanded', 'false');
    });
  };
}

if (!customElements.get('lunaveil-hotspots')) customElements.define('lunaveil-hotspots', LunaveilHotspots);

const wishlistKey = 'lunaveilWishlist';
const readWishlist = () => {
  try { return JSON.parse(localStorage.getItem(wishlistKey) || '[]'); } catch { return []; }
};

document.addEventListener('DOMContentLoaded', () => {
  const wishlist = document.querySelector('.lv-product-wishlist');
  if (wishlist) {
    const button = wishlist.querySelector('.lv-wishlist-button');
    const product = {
      id: wishlist.dataset.productId,
      handle: wishlist.dataset.productHandle,
      title: wishlist.dataset.productTitle,
      url: wishlist.dataset.productUrl,
      image: wishlist.dataset.productImage || ''
    };
    const viewedKey = 'lunaveilRecentlyViewed';
    let viewed = [];
    try { viewed = JSON.parse(localStorage.getItem(viewedKey) || '[]'); } catch { viewed = []; }
    viewed = viewed.filter((item) => item.id !== product.id);
    viewed.unshift(product);
    localStorage.setItem(viewedKey, JSON.stringify(viewed.slice(0, 8)));
  }

  document.querySelectorAll('.lv-recent-section').forEach((section) => {
    let items = [];
    try { items = JSON.parse(localStorage.getItem('lunaveilRecentlyViewed') || '[]'); } catch { items = []; }
    items = items.filter((item) => item.id !== section.dataset.currentProduct).slice(0, 4);
    if (!items.length) return;
    const grid = section.querySelector('.lv-recent-grid');
    items.forEach((item) => {
      const link = document.createElement('a');
      link.className = 'lv-recent-card';
      link.href = item.url;
      if (item.image) {
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = item.title;
        img.loading = 'lazy';
        link.append(img);
      }
      const title = document.createElement('span');
      title.textContent = item.title;
      link.append(title);
      grid.append(link);
    });
    section.hidden = false;
  });
});
